import { IconFont } from '@byecode/ui'
import styled from 'styled-components'

export const Icon = styled(IconFont)`
    cursor: pointer;
    color: var(--color-gray-400);
`

export const Container = styled.div``

export const AuthConfig = styled.div`
    padding: 0 16px 4px 16px;
    /* border-bottom: 1px solid var(--color-gray-200); */
`

export const AuthConfigInner = styled.div`
    /* height: 38px;
  background: #ECEFF4;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 4px 8px;
  cursor: pointer; */
`

export const Item = styled.div`
    width: 100%;
    padding: 12px 0 0 0;

    &:last-child {
        padding-bottom: 4px;
    }
`

export const Text = styled.span<{ size?: number; color?: string }>`
    font-size: ${({ size }) => size ?? 14}px;
    color: ${({ color }) => color ?? 'var(--color-black)'};
    display: flex;
    align-items: center;
    gap: 6px;
`

export const FormItemWrapper = styled.div`
    margin-top: 8px;
`

export const TooltipContent = styled.div`
    line-height: 22px;
    vertical-align: middle;
`
